var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(_vm.$route.meta.layout || 'div',{tag:"component"},[_c('div',[_c('router-view')],1)]),_c('notifications'),_c('cookie-consent-dialog',{ref:"cookieConsentDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }